import React from "react";
import { Grid, Box, Stack, Button, Typography } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { userProfile } from "../../features/auth/authAction";

const labels = {
  si: {
    perMonth: 'මසකට',
    discount: 'වට්ටම්',
    applyNow: 'දැන්ම අයදුම් කරන්න',
  },
  en: {
    perMonth: 'per month',
    discount: 'discount',
    applyNow: 'Apply Now',
  }
};

const PriceDetails = ({
  month, pricePerMonth, fullPrice, discount
}) => {
  const Navigation = useNavigate();
  const dispatch = useDispatch();
  const loggedUserDetails = useSelector((state) => state.auth.profileInfo?.user?.id)
  const id = Number(loggedUserDetails)
  const [lang, setLang] = React.useState(() => localStorage.getItem('language') || 'si');

  React.useEffect(() => {
    dispatch((userProfile()));
  }, [dispatch]);

  React.useEffect(() => {
    // Listen to storage events (for cross-tab communication)
    const onStorage = (e) => {
      if (e.key === 'language' && e.newValue) setLang(e.newValue);
    };
    window.addEventListener('storage', onStorage);

    // Poll for language changes (for same-tab updates)
    const interval = setInterval(() => {
      const currentLang = localStorage.getItem('language') || 'si';
      setLang(prevLang => {
        if (prevLang !== currentLang) {
          return currentLang;
        }
        return prevLang;
      });
    }, 500);

    return () => {
      window.removeEventListener('storage', onStorage);
      clearInterval(interval);
    };
  }, []);

  const t = labels[lang] ?? labels.si;

  const handlePrice = () => {
    dispatch((userProfile()));
    if (id) {
      Navigation(`/payment/${id}`)
    } else {
      Navigation('/login')
    }
  }

  return (
    <>
      <Grid xs={3} >
        <Box
          sx={{
            bgcolor: 'background.paper',
            pt: '5rem',
            pb: '5rem',
            pl: '2rem',
            pr: '2rem',
            margin: '2rem',
            display: 'flex',
            justifyContent: 'center',
            border: '1px solid #C3937C',
            borderRadius: '1rem',
            minWidth: '200px',
            color: 'text.primary',
            boxShadow: 3,
            transition: 'all 0.3s ease',
            '&:hover': {
              transform: 'translateY(-5px)',
              boxShadow: 6,
            }
          }}>
          <Stack spacing={2}>
            <Typography variant="h6" sx={{ color: 'text.primary', fontWeight: 700 }}>
              {month} {t.perMonth}
            </Typography>
            <Typography variant="h4" sx={{ fontSize: '28px', fontFamily: "monospace", color: 'primary.main', fontWeight: 700 }}>
              Rs. {pricePerMonth}
            </Typography>
            {discount > 0 ? (
              <>
                <Typography variant="body2" sx={{ color: 'text.secondary', textDecoration: 'line-through' }}>
                  Rs. {fullPrice}
                </Typography>
                <Typography variant="body1" sx={{ fontFamily: 'monospace', color: 'success.main', fontWeight: 600 }}>
                  {discount}% {t.discount}
                </Typography>
              </>
            ) : (
              <Box sx={{ height: '48px' }} /> // Placeholder to keep height consistent
            )}
            <Button
              variant="contained"
              sx={{
                mt: '2rem',
                backgroundColor: '#C3937C',
                color: (theme) => theme.palette.mode === 'dark' ? '#fff' : '#000',
                '&:hover': {
                  backgroundColor: '#EAD9C9',
                }
              }}
              onClick={handlePrice}
            >
              {t.applyNow}
            </Button>
          </Stack>
        </Box>

      </Grid>
    </>
  )
}

export default PriceDetails;